import { render } from "./RegistroSanitarioDetalle.vue?vue&type=template&id=583919cd"
import script from "./RegistroSanitarioDetalle.vue?vue&type=script&lang=js"
export * from "./RegistroSanitarioDetalle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__